import { gql } from '@apollo/client';

export const MOMENT_FIELDS = 'id title happenedOn activities instrument notes durationMinutes favorite recordingDurationSeconds recordingUpdatedAt createdAt updatedAt';
export const MUSIC_MOMENTS = gql`query GetMusicMoments($first: Int, $after: String, $search: String, $favorites: Boolean) { getMusicMoments(first: $first, after: $after, search: $search, favorites: $favorites) { nodes { ${MOMENT_FIELDS} } pageInfo { hasNextPage endCursor } } }`;
export const MUSIC_MOMENT = gql`query GetMusicMoment($id: ID!) { getMusicMoment(id: $id) { ${MOMENT_FIELDS} } }`;
export const SAVE_MUSIC = gql`mutation SaveMusicMoment($id: ID, $input: MusicMomentInput!) { saveMusicMoment(id: $id, input: $input) { ${MOMENT_FIELDS} } }`;
export const DELETE_MUSIC = gql`mutation DeleteMusicMoment($id: ID!) { deleteMusicMoment(id: $id) }`;
export const UPLOAD_MUSIC_RECORDING = gql`mutation UploadMusicRecording($id: ID!, $base64Data: String!) { uploadMusicRecording(id: $id, base64Data: $base64Data) { ${MOMENT_FIELDS} } }`;

/** Convert a saved moment into an editor draft without GraphQL metadata. */
export function momentDraft(moment) {
  return { title: moment?.title || '', happenedOn: moment?.happenedOn || localDate(),
    activities: moment?.activities || [], instrument: moment?.instrument || '', notes: moment?.notes || '',
    durationMinutes: moment?.durationMinutes ?? '', favorite: moment?.favorite || false };
}

/** Use the local calendar day rather than UTC for a new moment. */
export function localDate() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
